import { IsIn, IsNotEmpty, IsNumber, IsOptional } from "class-validator";

import { Constants } from "@eagerdog/constants";

import { IScentDogGamesScore } from "./scent-dog-games-score.interface";

export class ScentDogGamesScoreDto implements IScentDogGamesScore {
  @IsNotEmpty()
  @IsIn([
    Constants.score_result_type.qualified,
    Constants.score_result_type.not_qualified,
    Constants.score_result_type.absent,
  ])
  result_type: string;

  @IsOptional()
  @IsNumber()
  fault_count?: number;

  @IsOptional()
  search_time?: string;
}
